// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f4dfd8da77beccd64148","655":"95cfc1bcc105e92d3206"}[chunkId] + ".js";
};